
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 21 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.3 4.52L10 1.46V0H0v20h9.38l11.07-10-4.56-4.53.41-.95zM6 16H4v-2h2v2zm4-12.31l3.7 1.79-3.7 8.64V3.69zM17.55 10l-5.84 5.26L15 7.46 17.55 10z","fill":"#4FA2B7","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/designer_layers_svgs/design_layers_fill.svg